import { render, staticRenderFns } from "./EmailBuilder.vue?vue&type=template&id=afb814d6&scoped=true"
import script from "./EmailBuilder.vue?vue&type=script&lang=js"
export * from "./EmailBuilder.vue?vue&type=script&lang=js"
import style0 from "./EmailBuilder.vue?vue&type=style&index=0&id=afb814d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb814d6",
  null
  
)

export default component.exports